// --- API Hooks ---
import {
  useGetWishlistQuery,
  useToggleWishlistItemMutation,
  useAddWishlistItemMutation,
  useRemoveWishlistItemMutation,
} from "../templates/ecommerce/wishlist/api/wishlistApi";

// --- Custom Logic Hooks ---
import { useAddToWishlist } from "../templates/ecommerce/wishlist/hooks/useAddToWishlist";
import { useRemoveFromWishlist } from "../templates/ecommerce/wishlist/hooks/useRemoveFromWishlist";
import { useToggleWishlistItem } from "../templates/ecommerce/wishlist/hooks/useToggleWishlistItem";

// --- UI Components ---
import WishlistPage from "../templates/ecommerce/wishlist/components/WishlistPage/WishlistPage";
import WishlistPanel from "../templates/ecommerce/wishlist/components/WishlistPanel/WishlistPanel";
import WishlistToggleButton from "../templates/ecommerce/wishlist/components/common/WishlistToggleButton";

// --- Selectors ---
import {
  selectWishlistItems,
  selectWishlistCount,
  selectIsInWishlist,
} from "../templates/ecommerce/wishlist/wishlistSelectors";

export const wishlist = {
  // 1. API Data Fetching
  api: {
    useGetWishlistQuery,
    useToggleWishlistItemMutation,
    useAddWishlistItemMutation,
    useRemoveWishlistItemMutation,
  },

  // 2. Logic Hooks
  hooks: {
    useAddToWishlist,
    useRemoveFromWishlist,
    useToggleWishlistItem,
  },

  // 3. UI Components
  components: {
    WishlistPage,
    WishlistPanel,
    WishlistToggleButton,
  },

  // 4. Selectors
  selectors: {
    selectWishlistItems,
    selectWishlistCount,
    selectIsInWishlist,
  },
};
